module.exports = __webpack_public_path__ + "img/big-percentage.75a7c4fa.svg";